import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface stateProps {
    open:           boolean;
}

const initialState : stateProps = {
    open:    false,
};

export const bandejaSlice = createSlice({
    name: 'bandeja',
    initialState: initialState,
    reducers: {
        setReducerBandeja: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.open = payload.open;
        },
    },
})

export const { setReducerBandeja } = bandejaSlice.actions

export default bandejaSlice.reducer